import { useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, Search } from "lucide-react";
import { usePub, useHead } from "./PublicSite";
import { searchArticles } from "./helpSearch";

const CATS = ["start", "sending", "account"];

export const HelpIndex = () => {
  const { pt, lang, content, en } = usePub();
  const [q, setQ] = useState("");
  useHead(pt("meta.help_title"), pt("meta.help_desc"));
  const arts = Object.entries(content.articles || en.articles);
  const hits = searchArticles(arts, q, lang);
  return (
    <div className="pub-section" data-testid="help-page">
      <div className="pub-wrap">
        <h1 className="pub-h1 pub-h1-sm">{pt("help.title")}</h1>
        <p className="pub-lead">{pt("help.sub")}</p>
        <label className="pub-search"><Search className="h-5 w-5" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder={pt("help.search")} dir="auto" data-testid="help-search-input" /></label>
        {hits.length === 0 && <p className="pub-muted" data-testid="help-no-results">{pt("help.none")}</p>}
        {CATS.map((cat) => {
          const list = hits.filter(([, a]) => a.cat === cat);
          if (!list.length) return null;
          return (
            <section key={cat} className="pub-help-cat">
              <h2 className="pub-h3">{pt(`help.cat_${cat}`)}</h2>
              <div className="pub-help-grid">{list.map(([slug, a]) => (
                <Link key={slug} to={`/${lang}/help/${slug}`} className="pub-help-card" data-testid={`help-article-${slug}`}><h3>{a.title}</h3><p>{a.summary}</p></Link>
              ))}</div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

export const Article = () => {
  const { slug } = useParams();
  const { pt, lang, content, en } = usePub();
  const a = (content.articles || en.articles)[slug];
  useHead(a ? `${a.title} · Auditmail` : pt("meta.help_title"), a ? a.summary : pt("meta.help_desc"));
  if (!a) return <Navigate to={`/${lang}/help`} replace />;
  const more = Object.entries(content.articles || en.articles).filter(([s, x]) => s !== slug && x.cat === a.cat).slice(0, 3);
  return (
    <div className="pub-section" data-testid={`article-${slug}`}>
      <article className="pub-wrap pub-article">
        <Link to={`/${lang}/help`} className="pub-link" data-testid="article-back-link"><ArrowLeft className="am-flip inline h-4 w-4" /> {pt("help.back")}</Link>
        <h1 className="pub-h1 pub-h1-sm" data-testid="article-title">{a.title}</h1>
        <p className="pub-lead">{a.summary}</p>
        {["p1", "p2", "p3", "p4"].filter((k) => a[k]).map((k) => <p key={k} className="pub-prose">{a[k]}</p>)}
        {more.length > 0 && <aside className="pub-related"><h2 className="pub-h3">{pt("help.related")}</h2>
          {more.map(([s, x]) => <Link key={s} to={`/${lang}/help/${s}`} className="pub-link block" data-testid={`related-${s}`}>{x.title}</Link>)}</aside>}
      </article>
    </div>
  );
};
